import { render, staticRenderFns } from "./FundTransfersIcon.vue?vue&type=template&id=248c74c6&"
import script from "./FundTransfersIcon.vue?vue&type=script&lang=js&"
export * from "./FundTransfersIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('248c74c6')) {
      api.createRecord('248c74c6', component.options)
    } else {
      api.reload('248c74c6', component.options)
    }
    module.hot.accept("./FundTransfersIcon.vue?vue&type=template&id=248c74c6&", function () {
      api.rerender('248c74c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/accounting/income/FundTransfersIcon.vue"
export default component.exports